<template>
  <v-container class="pa-0">
    <ValidationObserver ref="validateObserver" v-slot="{ invalid }">
      <v-row dense>
        <v-col>
          <form autocomplete="off">
            <v-row dense>
              <v-col>
                <mb-select
                  v-model="covenant.beneficiaryId"
                  :items="beneficiaries"
                  itemText="name"
                  itemValue="id"
                  name="beneficiaryId"
                  label="Beneficiário"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-autocomplete
                  v-model="covenant.covenantId"
                  :items="covenants"
                  itemText="name"
                  itemValue="id"
                  name="covenant"
                  label="Convênio"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-input-text
                  v-model="covenant.cardNumber"
                  name="cardNumber"
                  label="Número do Cartão"
                  rules="required"
                />
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="6" cols="12">
                <mb-date
                  v-model="covenant.validate"
                  :allowedDates="(vl) => $moment(vl).isSameOrAfter($moment().startOf('day'))"
                  name="validate"
                  label="Validade do Cartão"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-text-button name="conv_cancel" label="Cancelar" @click="cancel" :primary="false" />
              </v-col>

              <v-col class="pb-5" align="right"
                xl="4" lg="4" md="4" sm="4" cols="12"
                :order="($vuetify.breakpoint.xsOnly) ? 'first' : 'last'"
              >
                <mb-text-button name="conv_save" label="Salvar"
                  :disabled="invalid"
                  :loading="saveBtnLoading"
                  @click="(covenant.id) ? update() : create()"
                />
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputText from '@/components/general/inputs/MbInputText';
import MbSelect from '@/components/general/inputs/MbSelect';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbAutocomplete from '@/components/general/inputs/MbAutocomplete';
import MbDate from '@/components/general/inputs/MbDate';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    covenant: {
      id: null,
      patientId: null,
      beneficiaryId: null,
      covenantId: null,
      cardNumber: null,
      validate: null,
    },
    beneficiaries: [],
    covenants: [],
    saveBtnLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.getBeneficiaries();
    this.getCovenants();

    if (this.value) {
      Object.keys(this.value)
        .filter(key => key in this.covenant)
        .forEach((key) => {
          this.covenant[key] = this.value[key];
        });
    }

    this.covenant.patientId = this.user.id;
  },
  methods: {
    save() {
      if (this.covenant.id) {
        this.update();
      } else {
        this.save();
      }
    },
    async create() {
      const isValid = await this.$refs.validateObserver.validate();
      if (isValid) {
        this.saveBtnLoading = true;

        const newCovenant = this.covenant;
        delete newCovenant.id;

        this.$store
          .dispatch('patientCovenants/create', newCovenant)
          .then((covenantSaved) => {
            this.covenant.id = covenantSaved.id;
            this.$emit('input', this.covenant);
            bus.$emit('message', {
              message: 'Convênio criado com sucesso!',
              type: 'success',
            });
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
    async update() {
      const isValid = await this.$refs.validateObserver.validate();
      if (isValid) {
        this.updateBtnLoading = true;

        this.$store
          .dispatch('patientCovenants/update', this.covenant)
          .then(() => {
            bus.$emit('message', {
              message: 'Convênio atualizado com sucesso!',
              type: 'success',
            });
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
    getBeneficiaries() {
      this.$store
        .dispatch('patientDependents/getFamily', this.user.id)
        .then((beneficiaries) => {
          this.beneficiaries = beneficiaries;
        });
    },
    getCovenants() {
      this.$store.dispatch('covenants/get').then((covenants) => {
        this.covenants = covenants;
      });
    },
    cancel() {
      this.$router.push('/covenants/list');
    },
  },
  watch: {
    value(vl) {
      if (vl) {
        Object.keys(vl)
          .filter(key => key in this.covenant)
          .forEach((key) => {
            this.covenant[key] = vl[key];
          });
      }
    },
  },
  components: {
    ValidationObserver,
    MbInputText,
    MbSelect,
    MbTextButton,
    MbAutocomplete,
    MbDate,
  },
};
</script>
